/* eslint-disable */
export default {
  'signixfrontend': '2b5dadda9d6ee314eb3c2b35014ea35b00914fb28835478a2744f07cad13b7de',
  '@signiapp/core': '1.5.268',
  '@signiapp/helpers': '0.3.10',
  '@signicat/designi': '^0.5.45',
  '@signiapp/signature': '1.8.241',
  '@signiapp/contact': '1.0.5',
};
